/**
 * v-reveal — fades + lifts an element into place the first time it enters view.
 * Usage:  v-reveal          (default)
 *         v-reveal="150"    (delay in ms)
 */
let observer = null

function ensureObserver() {
  if (observer || typeof IntersectionObserver === 'undefined') return observer
  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-reveal', 'in')
          observer.unobserve(entry.target)
        }
      }
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
  )
  return observer
}

export default {
  mounted(el, binding) {
    const delay = Number(binding.value) || 0
    el.style.setProperty('--reveal-delay', delay + 'ms')
    el.setAttribute('data-reveal', 'out')
    const obs = ensureObserver()
    if (obs) obs.observe(el)
    else el.setAttribute('data-reveal', 'in')
  },
  unmounted(el) {
    if (observer) observer.unobserve(el)
  }
}
